module.exports = __webpack_public_path__ + "img/title.a39bbf1e.png";